import { config } from 'config';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function RouteChangeHandler({ patternToCheck, setFsjpLocation }) {
  const location = useLocation(); // Obtiene la ubicación actual

  useEffect(() => {
    //console.log('Ejecuntando useEffect: ' + location.pathname);
    const serverName = window.location.hostname;
    setFsjpLocation(location.pathname.indexOf(patternToCheck) >= 0);

    console.log('serverName ', serverName);
    console.log('config.serverDomain ', config.serverDomain);

    setFsjpLocation(config.serverDomain.indexOf(serverName) >= 0);
    /*console.log(
      'setFsjpLocation ' + (location.pathname.indexOf(patternToCheck) >= 0),
    );*/
  }, [location, patternToCheck, setFsjpLocation]); // Se ejecuta cada vez que cambie la ubicación
  //({ patternToCheck, setFsjpLocation })
  return null; // No retorna ningún contenido visual
}

export default RouteChangeHandler;
